module.exports = __webpack_public_path__ + "static/media/fleets.c51e776f.png";